import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const OptionsButton = superstyled({
  name: 'SingleChoiceSelection',
  slot: 'Option',
  tag: Button,
  propsAdded: {
    fullWidth: true,
    variant: 'text'
  },
  styles: ({ theme }) => ({
    justifyContent: 'flex-start',
    padding: '1.375rem 1.25rem',
    backgroundColor: 'transparent',
    outline: `solid 1px ${theme.palette.border.dark}`,

    // add style if data-selected is true
    '&[data-selected="true"], &:focus:not(:focus-visible)': {
      backgroundColor: 'transparent',
      outline: `solid 2px ${theme.palette.info.main}`
    },

    // add style if data-selected is false
    '&[data-selected="false"]:hover': {
      outlineColor: 'currentColor'
    }
  })
});

export const Container = superstyled({
  name: 'SingleChoiceSelection',
  slot: 'Container',
  tag: Stack,
  styles: ({ theme }) => ({
    gap: theme.spacing(1.25)
  })
});
